export const styles = {
    searchIcon: {
        fontSize: '20px',
    },
    inputAdornment: {
        fontSize: '20px',
    },
};
